module.exports = __webpack_public_path__ + "img/Step2@2x.2cea33c8.jpg";